/** @format */

import { FormattedMessage } from 'gatsby-plugin-intl';
import React from 'react';
import { scroller } from 'react-scroll';
import styled from 'styled-components';

interface SecondaryNavProps {
  showSecondaryNav: boolean;
}

export const SecondaryNavbar: React.FC<SecondaryNavProps> = ({ showSecondaryNav }) => {
  const scrollSecondaryHandler = (elementId: string) => {
    scroller.scrollTo(elementId, {
      duration: 875,
      smooth: true,
      offset: -100,
    });
  };

  return (
    <SecondaryNav $showSecondaryNav={showSecondaryNav}>
      <ScondaryNavContainer>
        <ul>
          <li>
            <button onClick={() => scrollSecondaryHandler('galleryAnchor')}>
              <FormattedMessage id="pdp.photos" />
            </button>
          </li>
          <li>
            <button onClick={() => scrollSecondaryHandler('roomInfoAnchor')}>
              <FormattedMessage id="pdp.amenities" />
            </button>
          </li>
          <li>
            <button onClick={() => scrollSecondaryHandler('mapAnchor')}>
              <FormattedMessage id="pdp.location" />
            </button>
          </li>
        </ul>
      </ScondaryNavContainer>
    </SecondaryNav>
  );
};

export const SecondaryNav = styled.div<{ $showSecondaryNav: boolean }>`
  height: 80px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 0px;
  background-color: rgb(255, 255, 255);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 3;
  width: calc(100% - var(--scrollbar-gutter, 0%));
  animation-name: keyframe_1b8bzh6;
  animation-duration: 100ms;
  opacity: ${({ $showSecondaryNav }) => ($showSecondaryNav ? 1 : 0)};

  transition: all 0.3s ease-in-out;
`;

export const ScondaryNavContainer = styled.div`
  padding-inline: 10px;
  width: 100%;
  max-width: 1098px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;

  > ul {
    height: 100%;
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    gap: 10px;
    > li {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      > button {
        color: ${({ theme }) => theme.colors.joivy.black};
        font-size: 16px;
        background-color: transparent;
        border: none;
        text-transform: capitalize;
        cursor: pointer;
        height: 100%;
        position: relative;
        &:hover:after {
          position: absolute;
          bottom: 0;
          content: '';
          height: 4px;
          width: 100%;
          left: 0;
          background-color: ${({ theme }) => theme.colors.joivy.pink};
        }
      }
    }
  }
`;

export default SecondaryNav;
